<div class="x-section__headline" data-test-id="headline">
	<h2 class="mat-h1" tabindex="0" aria-labelledby="sr-label-adre">{{ aufgabe | labelByAufgabe }}</h2>
</div>
<div class="x-section__subline">
	<i class="material-icons" aria-hidden="true">contact_mail</i>
	<h3 class="mat-body margin-right-auto">Adressaten</h3>
	@if (aufgabe | hasResourceLink: linkRel.DOWNLOAD_KORRESPONDENZEN_ARCHIV) {
		<schir-int-client-button-round
				materialIcon="archive"
				data-test-id="download-korrespondenzen-archiv-button"
				(click)="downloadKorrespondenzenArchiv()"
				toolTip="Alle Korrespondenzen im Archiv downloaden"
				cssClass="focus-inwards-dark"
				class="scale-90"/>
		<schir-int-client-button-round
				materialIcon="text_snippet"
				data-test-id="download-korrespondenzen-merge-button"
				(click)="downloadKorrespondenzenMerge()"
				toolTip="Alle Korrespondenzen in einem Dokument downloaden"
				cssClass="focus-inwards-dark"
				class="scale-90"/>
	}
</div>
<div class="x-section__main" (drop)="drop($event)" (dragover)="allowDrop($event)" data-test-id="drop-kontakt-area">
	<div class="c-spinner" data-test-id="spinner" #spinner>
		<mat-spinner/>
	</div>
	@if (kontakteInAufgabe | async; as _kontakteInAufgabe) {
		<ul class="c-list">
			@for (kontakt of _kontakteInAufgabe; track getUrl(kontakt)) {
				<schir-int-client-adressat-in-aufgabe [adressat]="kontakt"/>
			}
		</ul>
	}
</div>
<span id="sr-label-adre" class="sr-only">{{ aufgabe | labelByAufgabe }} Adressaten</span>
